import React, { Component } from 'react'
import { Card, CardHeader, CardBody, Alert, FormGroup, Form, Label, Input, CardFooter, Button, } from 'reactstrap'
import { Link } from 'react-router-dom'
import timestamper from '../../../helpers/timestamper'
import queryString from 'query-string'
import { db } from '../../../config/firebaseconfig'
import getRequest from '../../../helpers/getRequest'
import incrementRegistrationCount from '../../../helpers/users/incrementRegistrationCount';

const uuid = require('uuid/v1')


/*
  <RegisterUser 
    code={this.props.code}
  />
*/

class RegisterUser extends Component {
  constructor(props) {
    super(props)

    this.state = {
      firstName: '',
      lastName: '',
      username: '',
      email: '',
      password: '',
      password2: '',
      isSaving: false,
      error: '',
      complete: false,
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  cancel() {
    this.props.submitCode('')
  }

  addUser() {
    this.setState({isSaving: true})
    let error = ''
    if (!this.state.firstName) {
      error = 'First name field is required.'
    } else if (!this.state.lastName) {
      error = 'Last name field is required.'
    } else if (!this.state.email && this.props.code.role === 'Educator') {
      error = 'Email is required.'
    } else if (!this.state.password) {
      error = 'Password is required.'
    } else if (!this.state.username && !this.state.email && this.props.code.role === 'Student') {
      error = 'Username or email is required.'
    } else if (this.state.password !== this.state.password2) {
      error = 'Passwords must match.'
    }
    if (this.state.email) {
      const checkAt = this.state.email.search('@') === -1
      const checkDot = this.state.email.search('.') === -1
      if (checkAt || checkDot) {
        error = 'Email invalid.'
      }
    }
    if (error) {
      this.setState({isSaving: false, error})
    } else {
      this.setState({error: ''})

      const schoolId = this.props.code.school
      db.collection('schools').doc(schoolId).get()
        .then((doc) => {
          const time = timestamper()
          const userId = uuid()
          let userRole = 'students'
          if (this.props.code.role === 'Teacher') {
            userRole = 'educators'
          }

          const school = doc.data()
          const batch = db.batch()
          const userRef = db.collection(userRole).doc(userId)
          const schoolRef = doc.ref

          const fullName = `${this.state.firstName} ${this.state.lastName}`

          let newUser = {
            id: userId,
            email: this.state.email,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            fullName,
            state: school.state,
            schoolDistrict: school.district,
            school: school.id,
            lastModified: time,
            created: time,
            validated: true,
            classes: {},
          }

          let schoolUpdateKey
          let baseUrl
          if (userRole === 'students') {
            newUser.assessments = {}
            newUser.username = this.state.username
            newUser.role = 'Student'
            schoolUpdateKey = `students.${userId}`
            baseUrl = 'https://us-central1-bellwork-cg1.cloudfunctions.net/manualAddStudent?'
          } else if (userRole === 'educators') {
            newUser.role = 'Teacher'
            newUser.isTeacher = true
            schoolUpdateKey = `teachers.${userId}`
            baseUrl = 'https://us-central1-bellwork-cg1.cloudfunctions.net/manualAddEducator?'
          }

          batch.set(userRef, newUser)

          batch.update(schoolRef, {[schoolUpdateKey]: true})

          const data = {
            id: userId,
            password: this.state.password,
          }        

          const query = queryString.stringify(data)
          const url = `${baseUrl}${query}`
          getRequest(url)
            .then(() => {
              batch.commit()
                .then(() => {
                  incrementRegistrationCount(this.props.code.id, userId)
                    .then((uses) => {
                      this.setState({isSaving: false, complete: true})
                      let query = ''
                      if (userRole === 'educators') {
                        query = `?gua=${userId}`
                      }
                      this.props.history.push(`/assessment/dashboard/6e60eb20-172e-11e8-8bfb-cb0010808928${query}`)
                    })
                    .catch((error) => {
                      console.log('incrementing code usage error', error)
                    })
                })
                .catch((error) => {
                  console.log('RegisterUser addUser error', error)
                  this.setState({error: 'Error saving user to database. Please try again later', isSaving: false})
                })
            })
            .catch((error) => {
              console.log('AddTeachersModal addTeacher error', error)
              this.setState({error: 'Error saving teacher to database.', isSaving: false})
            })

        })
    }
  }

  render() {

    let usernameFormGroup = null
    if (this.props.code.role === 'Student') {
      usernameFormGroup = (
        <FormGroup>
          <Label htmlFor='username'>Username</Label>
          <Input 
            type='text' 
            id='username' 
            name='username' 
            placeholder='bobby22009' 
            onChange={(e) => this.handleChange(e)} 
            value={this.state.username}
            className={this.state.error === 'Username or email is required.' && !this.state.username ? 'is-invalid' : null}              
          />
        </FormGroup>
      )
    }

    const passwordRequiredError = this.state.error === 'Password is required.' && !this.state.password
    const passwordMatchError = this.state.error === 'Passwords must match.' && this.state.password !== this.state.password2
    const passwordInvalid = passwordRequiredError || passwordMatchError

    let message = null
    if (this.props.code.role === 'Student') {
      message = (
        <p>
          {`Register for a student account at MasteryPrep.com 
          by completing this form. To register, you'll need to 
          specify either your email address or a unique username.`}
        </p>
      )
    } else if (this.props.code.role === 'Teacher') {
      message = (
        <p>
          {`Register for a teacher account at MasteryPrep.com 
          by completing this form.`}
        </p>
      )
    }

    let submitButton = (
      <Button 
        className={'ml-2'} 
        color='primary' 
        onClick={() => this.addUser()}
        disabled={this.state.complete}
      >
        {'Register'}
      </Button>
    )
    if (this.state.isSaving) {
      submitButton = (
        <Button 
          className={'ml-2'} 
          color='primary'
        >
          <i className="fa fa-spinner fa-lg fa-spin"></i>
        </Button>
      )
    }

    let cardFooter = null
    if (this.props.code.role === 'Student' || this.props.code.role === 'Teacher') {
      cardFooter = (
        <CardFooter>
          {submitButton}
          <Button onClick={() => this.cancel()} className='ml-2 mr-2' color='secondary'>Cancel</Button>
          {this.state.error ? `${this.state.error}` : ''}
          {this.state.complete ? 'Registration complete. Taking you to login...' : null}
        </CardFooter>
      )
    }
 
    let CardBodyContent = null
    if (this.props.code.role === 'Student' || this.props.code.role === 'Teacher') {
      CardBodyContent = (
        <div>
          {message}
          <Form>
            <FormGroup>
              <Label htmlFor='firstName'>First Name</Label>
              <Input 
                type='text' 
                id='firstName' 
                name='firstName' 
                placeholder='Bob' 
                onChange={(e) => this.handleChange(e)} 
                value={this.state.firstName}
                className={this.state.error === 'First name field is required.' && !this.state.firstName ? 'is-invalid' : null}              
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor='lastName'>Last Name</Label>
              <Input 
                type='text' 
                id='lastName' 
                name='lastName' 
                placeholder='Theteacher' 
                onChange={(e) => this.handleChange(e)} 
                value={this.state.lastName}
                className={this.state.error === 'Last name field is required.' && !this.state.lastName ? 'is-invalid' : null}              
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor='email'>Email</Label>
              <Input 
                type='text' 
                id='email' 
                name='email' 
                placeholder='bobtheteacher@example.com' 
                onChange={(e) => this.handleChange(e)} 
                value={this.state.email}
                className={
                  this.state.error === 'Email is required.' || this.state.error === 'Email invalid.' 
                  ? 'is-invalid' 
                  : null
                }              
              />
            </FormGroup>
            {usernameFormGroup}
            <FormGroup>
              <Label htmlFor='password'>Password</Label>
              <Input 
                type='password' 
                id='password' 
                name='password' 
                placeholder='password123' 
                onChange={(e) => this.handleChange(e)} 
                value={this.state.password}
                className={passwordInvalid ? 'is-invalid' : null}              
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor='password2'>Confirm Password</Label>
              <Input 
                type='password' 
                id='password2' 
                name='password2' 
                placeholder='password123' 
                onChange={(e) => this.handleChange(e)} 
                value={this.state.password2}
                className={passwordMatchError ? 'is-invalid' : null}              
              />
            </FormGroup>
          </Form>
        </div>
      )
    } else {
      CardBodyContent = (
        <Alert color='danger'>
          Error processing registration code. Please try another code by <Link to='/register'>clicking here</Link>.
        </Alert>
      ) 
    }

    return (
      <Card>
        <CardHeader>
          Register with Code {this.props.code ? this.props.code.id : ''}
        </CardHeader>
        <CardBody>
          {CardBodyContent}
        </CardBody>
        {cardFooter}
      </Card>
    )
  }
}

export default RegisterUser


// WEBPACK FOOTER //
// ./src/components/Users/RegisterWithCode/RegisterUser.js